"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventsDetailsTabMap = exports.eventsDetailsTab = void 0;
const eventsDetailsTab = exports.eventsDetailsTab = ['home', 'companiesLeaderboard', 'individualLeaderboard', 'internalLeaderboard', 'faq'];
const eventsDetailsTabMap = exports.eventsDetailsTabMap = {
  home: {
    labelKey: 'commons.challenges.navigation.home'
  },
  companiesLeaderboard: {
    labelKey: 'commons.challenges.leaderboard.by_companies_title'
  },
  individualLeaderboard: {
    labelKey: 'commons.challenges.leaderboard.by_cyclists_title'
  },
  internalLeaderboard: {
    labelKey: 'commons.challenges.leaderboard.internal_title'
  },
  faq: {
    labelKey: 'commons.challenges.navigation.faq'
  }
};